import { defineCustomElement } from 'vue'
import ProjectsList from './ProjectsList/ProjectsList.vue'
import GithubStars from './GithubStars/GithubStars.vue'

// One bundle for both elements, so Vue is loaded once per page.
// <project-list lang="en"></project-list>  (base-url="https://…" only for the dev server)
// <github-stars></github-stars>
const elements = {
  'project-list': ProjectsList,
  'github-stars': GithubStars,
}
for (const [tag, component] of Object.entries(elements)) {
  if (!customElements.get(tag)) {
    customElements.define(tag, defineCustomElement(component))
  }
}
